module.exports = __webpack_public_path__ + "assets/img/u785.605b71fe.svg";